import ColorModeProvider from "./context/ColorModeContext";
import { PrivacyPolicyProvider } from "./providers/PrivacyPolicyProvider";
import { Header } from "./components/Header/Header";
import AppRouter from "./routes/AppRouter";
import { Footer } from "./components/Footer/Footer";
import { ScrollToTop } from "./components/Content/ScrollToTop/ScrollToTop";
import "./i18nt";
import { useEffect } from "react";
import { LANGUAGE } from "./constants/localStorage";
import { useTranslation } from "react-i18next";
function App() {
  const { i18n } = useTranslation();
  useEffect(() => {
    const lang = localStorage.getItem(LANGUAGE);

    if (lang) {
      i18n.changeLanguage(lang);
    } else {
      localStorage.setItem(LANGUAGE, "sr");
      i18n.changeLanguage("sr");
    }
  }, [i18n]);
  return (
    <ColorModeProvider>
      <PrivacyPolicyProvider>
        <Header />
        <AppRouter />
        <Footer />
        <ScrollToTop />
      </PrivacyPolicyProvider>
    </ColorModeProvider>
  );
}

export default App;
